import { useEffect } from 'react';
import { useSafeLocation, useSafeNavigate } from '../hooks/useSafeRouter';

const QueryParamPersistor = () => {
  const location = useSafeLocation();
  const navigate = useSafeNavigate();

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);

//     if (!params.has('isReactApp')) {
//       params.set('isReactApp', 'true');
//       navigate(`${location.pathname}?${params.toString()}`, { replace: true });
//     }
//   }, [location, navigate]);

  return null; // No visual component, just logic
};

export default QueryParamPersistor;